import Vue from 'vue';

export default {
    methods: {
        async setSelectedListItemIndex(index = null, enableReadRecordOnListIndexChange = false, useListItemAsRecord = false) {

            try {
                this.l_selectedListItemIndex = index;
                let foundItem = this.l_list.find(item => item.__selected);
                if (foundItem) foundItem.__selected = false;
                if (index !== null) {
                    Vue.set(this.l_list[index], '__selected', true);
                    if (enableReadRecordOnListIndexChange) {
                        await this.readRecord(this.l_list[index][this.defaultCampaignIdName], this.l_list[index][this.defaultListRecordIdNameOutput], true);
                    } else if (useListItemAsRecord) {
                        this.setLocalRecord(this.l_list[index]);
                    }
                }
            } catch (err) {
                throw err;
            }
        },
        getSelectedListItemIndex() {
            return this.l_selectedListItemIndex;
        },
        getSelectedtListItem() {
            return this.getSelectedListItemIndex() !== null ? JSON.parse(JSON.stringify(this.l_list[this.getSelectedListItemIndex()])) : undefined;
        },
        getListItemByIndex(index) {
            return this.l_list[index] ? JSON.parse(JSON.stringify(this.l_list[index])) : null;
        },
        setListItemByIndex(index, item) {
            this.l_list[index] = item;
        },
        updateSelectedListItem(data){
            let item = this.getSelectedtListItem();
            for (let key in data) {
                item[key] = data[key];
            }
            this.setSelectedtListItem(item);
        },
        setSelectedtListItem(item) {
            let index = this.getSelectedListItemIndex();
            Object.keys(item).forEach(key => Vue.set(this.l_list[index], key, item[key]));
        },
        selectFirstListItem() {
            return this.setSelectedListItemIndex(0);
        },
        selectLastListItem() {
            return this.setSelectedListItemIndex(this.l_list.length - 1);
        },
        selectNextListItem() {
            let selectedListItemIndex = this.getSelectedListItemIndex();
            let nextIndex = selectedListItemIndex !== null ? selectedListItemIndex + 1 : 0;
            if (nextIndex < this.l_list.length) this.setSelectedListItemIndex(nextIndex);
        },
        selectPreviousListItem() {
            let selectedListItemIndex = this.getSelectedListItemIndex();
            let previousIndex = selectedListItemIndex !== null ? selectedListItemIndex - 1 : 0;
            if (previousIndex >= 0) this.setSelectedListItemIndex(previousIndex);
        },
        getListItemRecordIdByIndex(index) {
            try {
                return this.l_list[index][this.defaultListRecordIdNameOutput];
            } catch (err) {
                return undefined;
            }
        },
        getListItemCampaignIdByIndex(index) {
            try {
                return this.l_list[index][this.defaultCampaignIdName];
            } catch (err) {
                return undefined;
            }
        },
        getSelectedListItemRecordId() {
            return getListItemRecordIdByIndex(this.getSelectedListItemIndex());
        },
        getSelectedListItemCampaignId() {
            return getListItemCampaignIdByIndex(this.getSelectedListItemIndex());
        }
    },
    data() {
        return {
            l_selectedListItemIndex: null,
        }
    }
}